import React from 'react';
import ContentHubPage from './ContentHubPage';

const ResourceCenter: React.FC = () => <ContentHubPage kind="resources" />;

export default ResourceCenter;
